import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';

import moment from 'moment';

import { AppLayoutTop } from 'components/appComponents';
import { Button, DataGrid } from 'devextreme-react';
import { useQuery } from 'utils/useQuery';

import { useGetDriverSalaryDetailsQuery } from 'bus/comingNomenclatureMain/services/main';
import { useLazyGetEmployeeDetailQuery } from 'bus/employee/services/services';
import { EmployeeItem } from 'bus/employee/types';

import { SalaryDriversInfo, SalaryDriversInfoTotals } from './components';
import { onExporting } from './utils';

const ComingFare: FC = () => {
  const refGridMain = useRef<DataGrid | null>(null);
  const refGridAdjustment = useRef<DataGrid | null>(null);

  let { id } = useParams<{ id: string }>();
  let query = useQuery();

  const [fetchEmployeeDetail] = useLazyGetEmployeeDetailQuery();

  const dateBegin = query.get('dateBegin');
  const dateEnd = query.get('dateEnd');

  const [formEmployee, setFormEmployee] = useState<EmployeeItem | null>(null);

  const fullName = `${formEmployee?.name} ${formEmployee?.middleName} ${formEmployee?.surname}`;
  const dateBeginText = moment(dateBegin).format('DD.MM.YYYY');
  const dateEndText = moment(dateEnd).format('DD.MM.YYYY');
  const date = `${dateBeginText} - ${dateEndText}`;

  const { data } = useGetDriverSalaryDetailsQuery({
    driverId: +id,
    dateBegin: String(dateBegin),
    dateEnd: String(dateEnd),
  });

  const getEmployeeDetail = useCallback(async () => {
    await fetchEmployeeDetail({ id })
      .unwrap()
      .then((data) => {
        setFormEmployee({ ...data });
      });
  }, [fetchEmployeeDetail, id]);

  useEffect(() => {
    getEmployeeDetail();
  }, [getEmployeeDetail]);

  const exportGrids = () => {
    if (!data) return;

    onExporting(refGridMain, refGridAdjustment, data, fullName, {
      dateBeginText,
      dateEndText,
    });
  };

  return (
    <div>
      <AppLayoutTop title={`${fullName} (${date})`}>
        <Button text="Экспорт в excel" icon="xlsxfile" onClick={exportGrids} />
      </AppLayoutTop>
      <SalaryDriversInfoTotals
        adjustments={data?.adjustments || 0}
        balance={data?.balance || 0}
        dateBegin={moment(dateBegin).format('DD.MM.YYYY') || ''}
        dateEnd={moment(dateEnd).format('DD.MM.YYYY') || ''}
        outBalance={data?.outBalance || 0}
        pay={data?.pay || 0}
        toPay={data?.toPay || 0}
      />

      <SalaryDriversInfo ref={refGridMain} dateBegin={String(dateBegin)} dateEnd={String(dateEnd)} id={id} />
    </div>
  );
};

export default ComingFare;
